var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "u-reset",
      class: _vm.rootClasses,
      style: _vm.inlineStyle,
      attrs: { to: _vm.link.path }
    },
    [
      _c("div", { staticClass: "tile--content" }, [
        _c("h1", { staticClass: "tile--title u-reset" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _vm.subtitle
          ? _c("p", { staticClass: "tile--subtitle u-reset" }, [
              _vm._v(_vm._s(_vm.subtitle))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tile--arrow" },
          [
            _c("base-icon", {
              attrs: { symbol: "arrow-forward", size: "large" }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33492818", { render: render, staticRenderFns: staticRenderFns })
  }
}